<template>
    <div>

    </div>
</template>

<script>
    import {
        Dialog
    } from 'vant';

    export default {
        name: "GoodsList2",
        components: {
            Dialog,
        },
        props: {
            content: {
                type: Array,
                default: [],
            },


        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// GoodsList2.vue?15019afa